import { artifactName } from '../../server/utils/artifactInfo';

export const versionRegexSlice = '\\d\\.\\d+\\.\\d+';
export const hasMatch = (matchResult: string[]) => Array.isArray(matchResult) && typeof matchResult[1] === 'string';

export const extractVersionFromBaseUrl = (staticsBaseUrl: string): string => {
  if (typeof staticsBaseUrl !== 'string') {
    return;
  }

  const matchResult: string[] = staticsBaseUrl.match(new RegExp(`\/${artifactName}\/(${versionRegexSlice})`));

  if (!hasMatch(matchResult)) {
    return;
  }

  return matchResult[1];
};
